<template>
  <div id="waitDiv" class=" wait">
    <!--  style="background: url('../../../public/img/loader.gif') center no-repeat" -->
    <div class="col-xs-12 waitImg">
      <div class="center-block">
        <p class="waitText">Loading ...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewLoading",
};
</script>
